import { FormArray, FormControl, FormGroup } from '@angular/forms';
import { Params } from '@angular/router';
import { Company } from '@cargos/sprintpay-models';

export enum DynamicFieldType {
    INPUT = 'input',
    NUMBER = 'number',
    DROPDOWN = 'dropdown',
    RADIOBUTTON = 'radioButton',
    DATE = 'date',
    CHECKBOX = 'checkbox',
    FILE = 'file',
    TEXTAREA = 'textarea',
    AUTOCOMPLETE = 'autoComplete',
    CHIPGRID = 'chipGrid',
}

export interface DynamicFieldForm {
    name: FormControl<string | null>;
    label: FormControl<string | null>;
    placeholder: FormControl<string | null>;
    isDisabled: FormControl<boolean | null>;
    fieldType: FormControl<string | null>;
    options: FormArray<FormControl<string>>;
    selectedValidators: FormControl<string[] | null>;
    validations: FormArray<FormGroup<DynamicFieldValidation>>;
    id: FormControl<number | null>;
    section: FormControl<number | null>;
    company: FormControl<Company | null>;
    emailDomain: FormControl<string | null>;
    isReplacement: FormControl<boolean | null>;
    isHidden: FormControl<boolean | null>;
    subLabel: FormControl<string | null>;
    tooltipTitle: FormControl<string | null>;
    tooltipMessage: FormControl<string | null>;
    hint: FormControl<string | null>;
    value: FormControl<string | null>;
    isDynamic: FormControl<boolean | null>;
    isValueMappingEnabled?: FormControl<boolean | null>;
    mappedFieldName?: FormControl<string | null>;
}

export interface DynamicFieldValidation {
    id: FormControl<number | null>;
    name: FormControl<string | null>;
    value: FormControl<string | RegExp | string[] | RegExp[] | null>;
    message: FormControl<string | null>;
    title: FormControl<string | null>;
    type: FormControl<string | null>;
    apiValidator: FormControl<string | null>;
    params: FormControl<Params[] | null>;
    typeRequest: FormControl<string | null>;
}

export enum DynamicFieldValidator {
    REQUIRED = 'required',
    MINLENGTH = 'minlength',
    MAXLENGTH = 'maxlength',
    MIN = 'min',
    MAX = 'max',
    PATTERN = 'pattern',
    EMAIL = 'email',
    PREVENTED_HTML_STR = 'preventedHTMLStr',
    AWB_VALIDATOR = 'awbValidator',
    WEIGHT = 'weight',
    MULTIPLE = 'multiple',
    INVALID = 'invalid',
}

export interface DynamicFieldFormProperties {
    name: string | null;
    label: string | null;
    placeholder: string | null;
    isDisabled: boolean | null;
    fieldType: string | null;
    options: string[];
    selectedValidators: string[] | null;
    validations: DynamicFieldValidationProperties[];
}

export interface DynamicFieldValidationProperties {
    id: number | null;
    name: string | null;
    value: string | RegExp | string[] | RegExp[] | null;
    message: string | null;
    title: string | null;
    type: string | null;
    apiValidator: string | null;
    params: Params[] | null;
    typeRequest: string | null;
}

export const DynamicFieldPersistentNames: string[] = ['awb', 'amount', 'hawbId'];

export const DynamicFieldPersistentNamesThatCannotBeDisabled: string[] = ['awb', 'amount'];

export const DynamicFieldBaseName: string = 'extraField';

export interface DynamicFieldPrefillOption {
    value: string;
    label: string;
}

// Whitelisted context keys resolved at runtime by the checkout (cargoFacilities) when isDynamic is true.
export const DynamicFieldPrefillKeys: DynamicFieldPrefillOption[] = [
    { value: 'email', label: 'Logged-in email' },
    { value: 'notificationEmail', label: 'Notification email' },
    { value: 'firstName', label: 'First name' },
    { value: 'lastName', label: 'Last name' },
    { value: 'companyName', label: 'Company' },
    { value: 'phone', label: 'Phone' },
];

// Fields available for value mapping (used in mapped field name select)
export const DynamicFieldMappingKeys: DynamicFieldPrefillOption[] = [
    { value: 'notificationEmail', label: 'Notification email' },
    { value: 'customerReference', label: 'Customer reference' },
    { value: 'paymentType', label: 'Payment type' },
];
